import { dayjsUTC } from "@/helpers/dateHelper"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { WarrantsJob } from "@/models/admin/warrantsJob/warrantsJob"
import {
  IWarrantsJob,
  WarrantsJobStatus,
} from "@/models/admin/warrantsJob/warrantsJob.types"

/**
 * A single `warrants_job` row as returned by Hasura. Mirrors the generated
 * `Financials_Warrants_Job` row; kept as a narrow type so the parser only
 * depends on the columns it actually reads.
 */
export type WarrantsJobRaw = {
  id: number
  status: string
  message?: string | null
  started_at: string
  ended_at?: string | null
  created_at: string
  updated_at: string
  deleted_at?: string | null
}

export const WarrantsJobParser: IParser<IWarrantsJob, WarrantsJobRaw> = {
  toDomain(data) {
    try {
      // Hasura `timestamp` columns are naive UTC, so parse them as UTC and
      // convert to local time for display.
      return new WarrantsJob(
        data.id,
        data.status as WarrantsJobStatus,
        data.message ?? null,
        dayjsUTC(data.started_at),
        data.ended_at ? dayjsUTC(data.ended_at) : null,
        dayjsUTC(data.created_at),
        dayjsUTC(data.updated_at),
        data.deleted_at ? dayjsUTC(data.deleted_at) : null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
